// Les langues d'INTERFACE du produit, en un seul endroit (issue #137).
//
// Avant, chaque fichier tranchait pour lui-même : `lang === 'en' ? 'en' : 'fr'`
// dans une quarantaine d'endroits, mails, prompts, dates. Une troisième langue
// y serait tombée en silence sur le français. Ici, les tables sont typées
// `Record<UiLang, …>` : ajouter une langue à LANGUES_UI fait crier TypeScript
// à chaque table qui ne la connaît pas encore.
//
// Ce module ne dépend de rien : le navigateur (console, extension) et Node
// (serveur, mails) l'importent tous les deux.

export const LANGUES_UI = ['fr', 'en', 'nl', 'it', 'es'] as const

export type UiLang = (typeof LANGUES_UI)[number]

export function estLangueUi(v: unknown): v is UiLang {
  return typeof v === 'string' && (LANGUES_UI as readonly string[]).includes(v)
}

/** Une valeur venue d'ailleurs (base, corps de requête, en-tête) ramenée à une
 *  langue connue. Le français reste le repli : c'est la langue du produit. */
export function langueUi(v: unknown): UiLang {
  return estLangueUi(v) ? v : 'fr'
}

/** La locale des dates et des montants. Belge là où le produit l'est. */
export const LOCALE_UI: Record<UiLang, string> = { fr: 'fr-BE', en: 'en-GB', nl: 'nl-BE', it: 'it-IT', es: 'es-ES' }

/** Le nom de la langue écrit en français, pour les prompts (rédigés en français). */
export const NOM_LANGUE_FR: Record<UiLang, string> = { fr: 'français', en: 'anglais', nl: 'néerlandais', it: 'italien', es: 'espagnol' }

/** Le nom de la langue dans la langue elle-même, pour un sélecteur. */
export const NOM_NATIF: Record<UiLang, string> = { fr: 'Français', en: 'English', nl: 'Nederlands', it: 'Italiano', es: 'Español' }

/** Le nom de la langue telle que le rendu du CV l'attend (`outputLanguage`). */
export const LANGUE_DOCUMENT: Record<UiLang, string> = { fr: 'Français', en: 'English', nl: 'Nederlands', it: 'Italiano', es: 'Español' }

/** L'en-tête Accept-Language d'un navigateur ramené à une langue d'interface,
 *  parmi celles qu'on accepte de proposer. */
export function langueDepuisAcceptLanguage(entete: string, permises: readonly UiLang[]): UiLang {
  for (const morceau of entete.toLowerCase().split(',')) {
    const court = morceau.trim().slice(0, 2)
    if (estLangueUi(court) && permises.includes(court)) return court
  }
  return 'fr'
}
